import { useContacts, useContactsState } from "modules/app/contexts";
import React, { memo, useRef, useEffect } from "react";
import * as S from "../../styles";

const AudioType = ({ url }) => {
  const audioRef = useRef(null);
  const { setPrevMedia, setCurrentMedia } = useContacts();
  const { prevMedia, currentMedia } = useContactsState();

  const handlePlay = (e) => {
    const mediaType = e.target.tagName;
    const id = e.target.currentSrc.replace("blob:", "");
    setPrevMedia(currentMedia);
    setCurrentMedia({ type: mediaType, id: id });
  };

  useEffect(() => {
    if (
      audioRef &&
      audioRef.current &&
      prevMedia.id !== currentMedia.id &&
      prevMedia.type === "AUDIO"
    ) {
      audioRef.current.pause();
    }
  }, [currentMedia]);

  return (
    <>
      {url ? (
        <S.Audio controls ref={audioRef} onPlay={(e) => handlePlay(e)}>
          <source src={url} type="audio/mp3" />
        </S.Audio>
      ) : (
        <S.MessageLoading />
      )}
    </>
  );
};

export default memo(AudioType);
